// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"fd8a31e8f997a5d3fdbb","218":"a695d34bf2a62ec97b1a","231":"b860df5e416cca515fba","691":"c3284940817d7f98e9a6","774":"39695ae98968b28c3c62"}[chunkId] + ".js";
};